import React from 'react';
import { SignInViewModel } from './SignInViewModel';
import { SetupUIBindingForReactFunctionalComponent } from '../common/UIBinding';

export function SignIn(props: { viewModel: SignInViewModel }) {
    let viewModel = props.viewModel;
    SetupUIBindingForReactFunctionalComponent(props.viewModel);

    return <div className="form">
        <div className="field"><div className="name">Username</div><div className="value"><input id="username" type="text" value={viewModel.username} onChange={e => viewModel.username = e.target.value} /></div></div>
        <div className="field"><div className="name">Password</div><div className="value"><input id="password" type="password" value={viewModel.password} onChange={e => viewModel.password = e.target.value} /></div></div>
        <div className="field"><div className="name"></div><div className="value"><button className="submit" onClick={() => viewModel.submit()}>Sign In</button></div></div>
        <div className="field"><div className="name"></div><div className="value alert">{viewModel.error}</div></div>
    </div>;
}
